import React, { useState } from 'react';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

export default function Trolly() {

  const [cookies, setCookie] = useCookies(['accessToken']);
  const [wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();


  React.useEffect(() => {
  const handleGetWishlist = async () => {
    try {
      const url = `https://w-shop-backend.vercel.app/api/wishlist`;
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-type': 'application/json',
          'Authorization': 'Bearer ' + cookies.accessToken,
        },
      });
      const body = await response.json();
      if (body.status !== 'success') {
        throw new Error(body.message,);
      } else {
        setWishlist(body.data)
      }
    } catch (error) {
      console.log(error);
    }
  }
  handleGetWishlist()
},[cookies.accessToken, navigate])

  function visibleBadges() {
    let visibles
    wishlist.length < 1 ? (visibles = true) : (visibles = false)
    return visibles
  }


  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: -3,
      top: 7,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 4px',
    },
  }));

  return (
    <ul className="navbar-nav ms-auto me-5">
      <a href="/trolly" className=" text-decoration-none pt-md-0 pt-lg-1">
        <IconButton aria-label="cart">
          <StyledBadge badgeContent={wishlist.length} invisible={visibleBadges()} color="error">
            <img src={"/img/icon-trolli.png"} className="img-log " alt="img-logo" width={35} height={35}></img>
            <span className="list-sidebar d-md-inline d-lg-none ">Keranjang</span>
          </StyledBadge>
        </IconButton>
      </a>
    </ul>
  );
}
